/* eslint-disable react/prop-types */
import classNames from 'classnames';
import { CustomIcn } from 'antd/index';

const CustomIcon = ({ className }) => <CustomIcn className={classNames('custom-icon', className)} />;

export default CustomIcon;
